import React, { useContext, useEffect } from 'react';
import Odd from '../../common/Odd';
import { GROUPED_VIEW_MARKETS, SERVING_SPORTS } from '../../data/constants';
import { getStreamingId } from '../../data/streaming/streamingUtils';
import { classIf } from '../../data/utils/classIf';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getLiveAggs } from '../../data/utils/getLiveAggs';
import { getLiveMatchPathname } from '../../data/utils/getLiveMatchPathname';
import { getLiveMatchWindowLocationHash } from '../../data/utils/getLiveMatchWindowLocationHash';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import { parseWindowLocationHash } from '../../data/utils/parseWindowLocationHash';
import { toggleFavouriteMatchInStorage } from '../../data/utils/toggleFavouriteMatchInStorage';
import PartialScores from '../../prematch/tournament/PartialScores';
import { LiveContext } from '../Live';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import GroupedView from '../../common/GroupedView';

function getMatchUniqueIdFromHash(){
    const parsedData =  parseWindowLocationHash(true);
    return parsedData && parsedData.matchUniqueId;
}

function LiveTournamentMatch(props) {
    const liveContext = useContext(LiveContext);

    const match = props.match;
    let bets = match.bets;
    let betsList = bets;
    if (liveContext.section === 'favorites') {
        betsList = [bets[0]];
    } else {
        betsList = liveContext.expandedView ? bets : liveContext.bet ? bets.filter(b => b.id === liveContext.bet.id) : [bets[0]];
    }

    if (betsList.length === 1) {
        const sportId = match.sportRef;
        const agg = getLiveAggs(sportId, betsList[0].aggId);
        if (agg.scommesse.length === 1 && agg.scommesse[0].odds.length === 0) {
            betsList = [];
            if (match.team2 == null) {
                match.team2 = agg.descrizione;
            }
        }
    }

    betsList.forEach(bet => {
        bet.odds.forEach(odd => {
            if (odd.matchData == null) {
                odd.matchData = {
                    id: match.id,
                    pal: match.pal,
                    avv: match.avv,
                    alias: match.alias,
                    desc: match.desc,
                    uniqueId: match.uniqueId,
                    sportDesc: match.sportDesc,
                    tournamentDesc: match.tournamentDesc,
                    sportRef: match.sportRef,
                    timestamp: match.timestamp,
                    timestampDB: match.timestampDB,
                    str: match.str
                };
            }
            if (odd.betData == null) {
                odd.betData = {
                    id: bet.id,
                    desc: bet.desc,
                    handicap: bet.handicap,
                    tipoHandicap: bet.tipoHandicap,
                    legabile: bet.legabile,
                    isLive:true,
                    dia: bet.dia,
                    eqs: bet.eqs
                };
            }
            odd.uniqueId = `${odd.matchData.uniqueId}_${odd.betData.id}_${odd.betData.handicap}_${odd.id}`;
        });
    });
    // betsList = filtraParametriche(betsList);

    const streamingId = getStreamingId(props.streaming);

    function handleClick() {
        liveContext.openMatch(match,true);
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        e.preventDefault();
        liveContext.toggleFavorite(match, props.aggregata);
        toggleFavouriteMatchInStorage(match.uniqueId, match, props.aggregata);
    }

    //Need to wait for tournaments before show the match
    useEffect(function() {
        if(liveContext.tournaments){
            const matchUniqueId = getMatchUniqueIdFromHash();
            if(props.match.uniqueId == matchUniqueId){
                liveContext.openMatch(match,true);
            }
        }
        
    },[liveContext.tournaments]);

    const score = props.match.score;
    const totalScore = score.formattedScores.find(sc => sc.isTotalScore);

    const isFavorite = liveContext.favorites[match.uniqueId] !== undefined;
    const matchHref = getLiveMatchPathname()+getLiveMatchWindowLocationHash(match.sportRef, match.categoryRef, match.tournamentRef, match.id);

    let groupedView = false;
    if (bets.length === 1 && GROUPED_VIEW_MARKETS.includes(bets[0].cs)) {
        groupedView = true;
    }

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <div className="avvenimento">
                {/*  <Link to={matchHref} rel="nofollow" > */}
                    <div className="info-avvenimento-live" onClick={handleClick}>
                        <div className="info-base">
                                {liveContext.sortType !== 'league' &&
                                    <span className={"img-fluid ico-cat iconCategoryLive " + (iconCategoryCssClass(match.sportRef, match.categoryRef, match.iconClass))}></span>
                                }
                                <div className="nome-avvenimento">
                                    {SERVING_SPORTS.includes(match.sportRef) ?
                                        <>
                                            <span className={match.score.srv === 1 ? "text-small service active" : "text-small service"}>{match.team1}</span>
                                            <span className={match.score.srv === 2 ? "text-small service active" : "text-small service"}>{match.team2}</span>
                                        </>
                                        :
                                        <>
                                            <span className="text-small">{match.team1}</span>
                                            <span className="text-small">{match.team2}</span>
                                        </>
                                    }
                                </div>
                            <div className="info-match push-right">
                                <span className="current-period text-small push-right">{score.periodo} {score.currentMinute?"("+score.currentMinute+"')":""}</span>
                                <PartialScores scores={match.score.formattedScores} />
                                {streamingId &&
                                    <span className="live-tv-icon push-right"></span>
                                }
                            </div>
                            {totalScore &&
                                <div className="info-score">
                                    <span className="text-small">{totalScore.s1}</span>
                                    <span className="text-small">{totalScore.s2}</span>
                                </div>
                            }
                            <div className="fav-button-container" onClick={toggleFavorite}>
                                <i className={"fav-button fa fa-star" + classIf(isFavorite, 'giallo')} ></i>
                            </div>
                        </div>
                    </div>
                {/*  </Link> */}
                {betsList.map(bet => {
                    {/* if (bet.parametrica) {
                        return (
                            <React.Fragment key={bet.id}>
                                <div className="label-desc-scom-vista-estesa">{bet.desc}</div>
                                <HandicapSelectorBet bets={match.betsById.get(bet.id)} />
                            </React.Fragment>
                        );
                    } */}

                    if (groupedView) {
                        return <GroupedView match={match} bet={bets[0]} />;
                    }

                    return (
                        <React.Fragment key={bet.uniqueId}>
                            {liveContext.expandedView &&
                                <div className="label-desc-scom-vista-estesa">{getBetDescription(bet, true)}</div>
                            }
                            <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                                {bet.odds.map(odd => {
                                    return <Odd key={odd.uniqueId} {...odd} matchData={props.match} />;
                                })}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
}

export default LiveTournamentMatch;